module.exports = __webpack_public_path__ + "static/media/phaser_bubble.9635eaa4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/phaser_bubble.png
// module id = 2359
// module chunks = 0